import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useApp } from '@/contexts/AppContext';

export default function Designers() {
  const { api, t } = useApp();
  const [list, setList] = useState([]);
  useEffect(() => { api.get('/designers').then((r) => setList(r.data || [])); }, [api]);

  const grouped = list.reduce((acc, d) => {
    const l = d.name[0].toUpperCase();
    (acc[l] = acc[l] || []).push(d);
    return acc;
  }, {});

  return (
    <div className="max-w-7xl mx-auto px-6 md:px-10 py-16" data-testid="designers-page">
      <span className="overline text-accent">A–Z</span>
      <h1 className="font-display text-5xl sm:text-7xl mt-3 tracking-tight">{t('nav.designers')}</h1>
      <p className="mt-6 max-w-xl font-light text-muted-foreground">The world's most coveted maisons, all authenticated and curated.</p>

      <div className="mt-16 grid grid-cols-1 md:grid-cols-3 gap-x-12 gap-y-16">
        {Object.keys(grouped).sort().map((letter) => (
          <div key={letter}>
            <div className="font-display text-3xl border-b border-foreground pb-3 mb-4">{letter}</div>
            <ul className="space-y-2">
              {grouped[letter].map((d) => (
                <li key={d.name}>
                  <Link to={`/shop?designer=${encodeURIComponent(d.name)}`} className="flex justify-between text-sm font-light link-underline" data-testid={`des-${d.name}`}>
                    <span>{d.name}</span>
                    <span className="text-muted-foreground">{d.count}</span>
                  </Link>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
    </div>
  );
}
